/* src/app/shared/watch-face/watch-face.component.scss */
.watchFace {
  width: 50vw;
  height: 50vw;
  background-color: black;
  color: white;
  border-radius: 50%;
  pointer-events: none;
}
.topIcon {
  width: 6vw;
  top: 4vw;
  position: absolute;
  left: 23vw;
}
.watchFaceBottomHalf {
  display: inline-flex;
  padding-top: 2vw;
}
.watchFaceTopHalf {
  height: 25vw;
  text-align: center;
  font-size: 10vw;
  padding-top: 12vw;
}
.watchFaceBottomLeft {
  padding-left: 8vw;
  padding-right: 1vw;
}
.watchFaceBottomRight {
  padding-left: 1vw;
  max-width: 20vw;
  font-size: 5vw;
}
/*# sourceMappingURL=watch-face.component.css.map */
